<tiime-input-container
  tiimeFormInputContainer
  contentId="businessUnit"
  [label]="label"
  [required]="required"
  [errorMessage]="errorMessage?.message"
  [small]="small"
>
  <tiime-select
    id="businessUnit"
    [formControl]="control"
    [customValue]="control?.value ? control.value.name : ''"
    [multiple]="multiple"
    (selectionChange)="emitSelectionChange($event)"
    (closeOptionsPanel)="closeOptionsPanel()"
    data-cy="business-unit-select"
  >
    <input
      tiimeSelectInput
      [placeholder]="searchPlaceholder"
      [formControl]="searchControl"
      appFormFocusObserve
      (formChanges)="searchControlChanges()"
    />
    <div tiimeSelectOptions data-cy="business-unit-select-options">
      @if (allowEmptyOption) {
        <mat-option [value]="null"></mat-option>
      }
      @for (
        businessUnit of filteredSelectorData
          | businessUnitsWithoutArchived: control?.value?.id : searchControl.value
          | sortByKey: 'name';
        track businessUnit.id
      ) {
        <mat-option [value]="businessUnit" [disabled]="!!businessUnit.archivedAt">
          <div class="tiime-option">
            <span class="option-name">{{ businessUnit.name }}</span>
            @if (!!businessUnit.archivedAt) {
              <mat-icon class="icon" svgIcon="icon-archived" color="primary"></mat-icon>
            }
          </div>
        </mat-option>
      }
    </div>
  </tiime-select>
  @if (infoMessage()) {
    <mat-icon tiimeSuffix fontSet="fontastic" fontIcon="icon-ic-info" [tiimeTooltip]="infoMessage()" />
  }
</tiime-input-container>
